export default function AboutSection() {
  return (
    <section id="about" className="w-full bg-[#F7F6F3] py-24 md:py-36">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left */}
          <div>
            <p className="text-emerald-600 text-xs font-semibold tracking-[0.2em] uppercase mb-4">Who We Are</p>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-black text-[#1A1A1A] leading-tight mb-6 font-['Space_Grotesk']">
              Expert Team.<br />
              <span className="text-[#1A1A1A]/40">Modern iOS</span><br />
              Solutions.
            </h2>
            <p className="text-[#666] text-lg leading-relaxed mb-8">
              MAGRA d.o.o. is a dedicated iOS development studio built by engineers and designers who are passionate about mobile technology. We focus on building products that are fast, secure, and genuinely useful.
            </p>
            <p className="text-[#666] text-lg leading-relaxed">
              Our team combines deep technical expertise with a user-first design philosophy, ensuring every application we ship meets the highest standards of quality and performance on the iOS platform.
            </p>
          </div>

          {/* Right */}
          <div className="flex flex-col gap-6">
            <div className="rounded-2xl overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/a34a4badfb385d5aa91a4c8bd5760b26.jpg"
                alt="MAGRA d.o.o. development team"
                className="w-full h-64 object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
